// extracted by mini-css-extract-plugin
module.exports = {"crashed":"ScreenErrorBoundary_crashed__udjW2","actions":"ScreenErrorBoundary_actions__27Xi5"};